module.exports = __webpack_public_path__ + "img/close.b94d0f7a.svg";